import { Outlet, useNavigate, useParams } from 'react-router';

import { Main } from 'src/components/Layout';
import { Tabs, TabsList, TabsTrigger } from 'src/components/ui/tabs';

import { resourcesTabs } from '../model';

const HelpResourcesLayout = () => {
  const navigate = useNavigate();
  const { '*': path = '' } = useParams();

  const onValueChange = (value: string) => navigate(`/help-resources/${value}`);

  return (
    <Main
      title="Help and resources"
      headerChildren={
        <Tabs value={path} onValueChange={onValueChange} className="p-6 pb-0">
          <TabsList className="justify-start p-0 h-9 md:h-12 bg-white">
            {resourcesTabs.map(({ value, label }) => (
              <TabsTrigger
                value={value}
                key={value}
                className="rounded-none border-b-2 border-transparent data-[state=active]:border-foreground data-[state=active]:shadow-none h-full px-3 transition-all duration-300 font-semibold"
              >
                {label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      }
      className="bg-background-secondary"
    >
      <Outlet />
    </Main>
  );
};

export default HelpResourcesLayout;
